import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { CircularProgress, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function BrokerRedirectHandler() {
    const navigate = useNavigate();
    const started = useRef(false);
    const [message, setMessage] = useState('Connecting your Broker account...');
    const [busy, setBusy] = useState(true);
    useEffect(() => {
        if (started.current) return;
        started.current = true;
        const query = Object.fromEntries(new URLSearchParams(window.location.search));
        const expected = sessionStorage.getItem('broker_tracking_id');
        // Remove credentials from the address bar before making any requests.
        window.history.replaceState(null, '', window.location.pathname);
        const complete = async () => {
            try {
                if (!expected || query.state !== expected) throw new Error('Login state mismatch. Start Connect again from your dashboard.');
                const token = localStorage.getItem('token');
                if (!token) throw new Error('Sign in to TradingBot and start Connect again.');
                const result = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/broker-callback/init-completed`,
                    { query }, { headers: { Authorization: `Bearer ${token}` } });
                setMessage(result.data.warning || 'Broker connected successfully.');
            } catch (error) {
                setMessage(error.response?.data?.detail || error.message || 'Broker connection failed. Please try again.');
            } finally {
                sessionStorage.removeItem('broker_tracking_id');
                setBusy(false);
            }
        };
        complete();
    }, []);
    return <Box sx={{ textAlign: 'center', mt: 8 }}>
        {busy && <CircularProgress />}
        <Typography mt={2}>{message}</Typography>
        {!busy && <Button onClick={() => navigate('/dashboard')}>Back to dashboard</Button>}
    </Box>;
}
